import React, { Component } from 'react'
import connect from '../utils/connect'

class Preloader extends Component {
  render() {
    return !this.props.isPreloaderShow
      ? <div />
      : <div className='share-dialog-container'>
      <div className='share-dialog-popup'>
        <div className='share-dialog-msg'>
          Подождите, идёт загрузка...
        </div>
      </div>
    </div>
  }
}

const mapStateToProps = ({ global: { isPreloaderShow } }) => ({ isPreloaderShow })

export default connect(mapStateToProps)(Preloader)



// WEBPACK FOOTER //
// app/javascript/src/components/preloader.jsx